<div class="full-landing-image sx-bnr-inr overlay-wraper  bg-top-center"
    style="background-image:url({{data.background}});">
    <div class="overlay-main bg-white opacity-0"></div>

    <div class="container">
        <div class="sx-bnr-inr-entry">
            <div class="banner-title-outer">
                <div class="banner-title-name">
                    <span class="sx-bnr-sm-title">Maven Merge</span>
                    <h2 class="sx-title">{{data.title}}</h2>
                </div>
                <!-- BREADCRUMB ROW -->
                <div>
                    <ul class="sx-breadcrumb breadcrumb-style-2">
                        <li><a routerLink="/index">Home</a></li>
                        <li>{{data.crumb}}</li>
                    </ul>
                </div>
                <!-- BREADCRUMB ROW END -->

            </div>

        </div>
    </div>
    <div class="sx-bnr-outline-text">
        <h1> {{data.watermark}}</h1>
    </div>

</div>